export const CLIENT_SIDE_SEARCH_DROPDOWN_LIMIT = 1000;
export const SERVER_SIDE_SEARCH_DROPDOWN_LIMIT = 1000;
export const SERVER_MIN_SEARCH_TERM_LENGTH = 3;

export const SEPARATOR = ':::';

export const mapIdsToScopeItem =
  <T extends { id: string; description: string }>(optionsMap: Map<string, T>) =>
  (ids: string[]) =>
    ids.length
      ? ids.map((id) => ({
          id,
          description: optionsMap.get(id)?.description ?? '',
        }))
      : null;

export const getConcatenatedOptionId = (option: {
  id: string;
  description: string | null;
}) => `${option.id}${SEPARATOR}${option.description}`;

export const getScopeItemFromConcatenatedId = (optionId: string) => {
  const [id, description] = optionId.split(SEPARATOR);

  return {
    id,
    description: description ?? null,
  };
};
